import { render, staticRenderFns } from "./software--detail.vue?vue&type=template&id=fa710416&scoped=true&"
import script from "./software--detail.vue?vue&type=script&lang=js&"
export * from "./software--detail.vue?vue&type=script&lang=js&"
import style0 from "./software--detail.vue?vue&type=style&index=0&id=fa710416&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa710416",
  null
  
)

export default component.exports